import { Component, Input } from '@angular/core'
import { ContactInfo } from '../../../types/mpup-types'

export const contactInfos: { [key: string]: ContactInfo } = {
  DE: {
    phone: '+49 2204 8306 3031',
    email: 'macspickup@miltenyi.com',
  },
  GB: {
    phone: '+44 1483 799 800',
    email: 'macspickupUK@miltenyi.com',
  },
  US: {
    phone: '+1 866 811 4466',
    email: 'macspickupUSA@miltenyi.com'
  },
  FR: {
    phone: '+33 1 56 98 16 16',
    email: 'macspickupFR@miltenyi.com',
  }
}

@Component({
  selector: 'mb-mpup-contact-info',
  templateUrl: './mpup-contact-info.component.html',
  styleUrls: ['./mpup-contact-info.component.scss']
})
export class MpupContactInfoComponent {

  @Input()
  contact!: string

  constructor () {
  }

  getContact (): ContactInfo {
    return contactInfos[this.contact]
  }
}
